var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.readonly
    ? _c("MantenedorGridVerDetalle", {
        attrs: {
          "grid-options": _vm.gridOptions,
          "row-data": _vm.actividadSeleccionados
        }
      })
    : _c("AsociacionGrid", {
        attrs: {
          "grid-options": _vm.gridOptions,
          "row-data": _vm.actividades,
          esEditar: _vm.esEditar
        }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }